import React, { Fragment } from "react";
import correctIcon from "../../../../Assests/correct-icon.svg";
import incorrectIcon from "../../../../Assests/incorrect-icon.svg";

const quizResultTextClass =
    "m-0 text-left font-normal text-[20px] leading-[27px] tracking-normal text-[#161616] font-['Segoe_UI',sans-serif]";
const quizExplanationLabelClass =
    "text-left font-bold text-[20px] leading-[27px] tracking-normal text-[#161616] font-['Segoe_UI',sans-serif]";

function QuizeResults({
    results,
    serverScore,
    handleRetakeQuiz,
    onChangeLicenseCategory,
}) {
    const totalQuestions = results.length;
    const attemptedQuestions = results.filter((item) => !item.notAttempted);
    const correctAnswersCount = attemptedQuestions.filter(
        (item) => item.isCorrect
    ).length;

    const percentageCorrect =
        serverScore?.percent != null
            ? Number(serverScore.percent)
            : totalQuestions > 0
            ? (correctAnswersCount / totalQuestions) * 100
            : 0;

    const scoreLabel =
        serverScore?.scoreCorrect != null && serverScore?.scoreTotal != null
            ? `You scored ${Math.round(percentageCorrect)}% ( ${serverScore.scoreCorrect} of ${serverScore.scoreTotal} )`
            : `You scored ${Math.round(percentageCorrect)}% ( ${correctAnswersCount} of ${totalQuestions} )`;

    const cardShadow = "0px 0px 22px #00000042";
    const retakeShadow = "0px 0px 22px #0000003B";

    const retakeButtonStyle = {
        boxShadow: retakeShadow,
        border: "2px solid #A1A3EF",
        borderRadius: "11px",
        opacity: 1,
        outline: "none",
    };
    const retakeBtnClass =
        "appearance-none cursor-pointer bg-transparent py-2.5 px-8 text-center text-[22px] font-normal text-[#A1A3EF] outline-none ring-0 transition duration-300 hover:bg-[#A1A3EF] hover:text-white focus-visible:bg-[#A1A3EF] focus-visible:text-white focus-visible:ring-2 focus-visible:ring-[#A1A3EF] focus-visible:ring-offset-2 active:bg-[#A1A3EF] active:text-white";

    const changeCategoryButtonStyle = {
        width: "276px",
        height: "55px",
        backgroundColor: "#A1A3EF",
        border: "none",
        borderWidth: 0,
        borderRadius: "11px",
        boxShadow: cardShadow,
        opacity: 1,
        boxSizing: "border-box",
        outline: "none",
    };
    const solidBtnClass =
        "appearance-none flex cursor-pointer items-center justify-center border-0 px-2 text-center text-[22px] font-normal leading-tight text-white outline-none ring-0 transition duration-300 hover:text-white focus-visible:text-white focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#A1A3EF] active:text-white";

    return (
        <div className="mx-auto mt-10 flex w-[80%] flex-col gap-10  ">
            <div className=" flex flex-col items-center  justify-center gap-20 lg:flex-row lg:gap-40">
                <div
                    className="flex min-h-[431px] w-[300px] flex-col items-center rounded-[17px] p-5 xs:w-[400px] sm:w-[450px] md:w-[600px] lg:w-[500px]"
                    style={{
                        boxShadow: cardShadow,
                    }}
                >
                    <div className="flex w-full flex-wrap items-center justify-center gap-2">
                        {results?.map((item, index) => (
                            <div
                                key={index}
                                className={`${
                                    item?.notAttempted
                                        ? "flex h-[52px] w-[53px] items-center justify-center rounded-[10px] border-0 bg-[#FFC31B]"
                                        : item?.isCorrect === true
                                        ? "flex h-[52px] w-[53px] items-center justify-center rounded-[10px] border border-solid border-[#8DF4A9] bg-[#8DF4A9]"
                                        : item?.isCorrect === false
                                        ? "flex h-[52px] w-[53px] items-center justify-center rounded-[10px] border border-solid border-[#FF7C7C] bg-[#FF7C7C]"
                                        : "flex h-[52px] w-[53px] items-center justify-center rounded-[10px] border border-solid border-[#834AFF] bg-[#D5D6FF]"
                                }`}
                            >
                                <h2 className="text-[25px] font-bold">
                                    {index + 1}
                                </h2>
                            </div>
                        ))}
                    </div>

                    <div className="mt-auto flex w-full flex-col items-center gap-8 pt-5">
                        <h2 className="text-center font-semibold text-[#161616]">
                            {scoreLabel}
                        </h2>
                        <div className="flex flex-row flex-wrap items-center justify-center gap-x-5 gap-y-2">
                            <div className="flex items-center gap-2">
                                <div className="h-[10px] w-[10px] shrink-0 rounded-full bg-[#FFC31B]" />
                                <span className="text-[23px] font-bold">Skip</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <div className="h-[10px] w-[10px] shrink-0 rounded-full bg-[#8DF4A9]" />
                                <span className="text-[23px] font-bold">Correct</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <div className="h-[10px] w-[10px] shrink-0 rounded-full bg-[#FF7C7C]" />
                                <span className="text-[23px] font-bold">Incorrect</span>
                            </div>
                        </div>
                        <div className="flex w-full flex-row flex-nowrap items-center justify-center gap-3">
                            <button
                                type="button"
                                onClick={handleRetakeQuiz}
                                style={retakeButtonStyle}
                                className={retakeBtnClass}
                            >
                                Retake
                            </button>
                            <button
                                type="button"
                                onClick={onChangeLicenseCategory}
                                style={changeCategoryButtonStyle}
                                className={solidBtnClass}
                            >
                                Change Licence Category
                            </button>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col gap-10  px-5 sm:w-[450px] md:w-[600px] lg:w-[500px]">
                    <h2 className="text-[38px]">
                        Hire an instructor for Class B licensing
                    </h2>
                    <p className="text-justify text-[24px]">
                        For expert guidance and a safe testing experience,
                        consider hiring a qualified instructor to conduct your
                        road test. Their expertise ensures you're well-prepared
                        and confident, maximizing your chances of success while
                        prioritizing safety.
                    </p>
                    <div
                        className="inline-block w-fit cursor-pointer rounded-[11px] bg-[#A1A3EF] py-3 px-5 text-right text-[22px] font-normal text-white shadow-lg transition duration-300 hover:shadow-xl"
                    >
                        Hire Instructor
                    </div>
                </div>
            </div>

            <div
                className="mx-auto flex w-full max-w-[1127px] flex-col items-center justify-center gap-10 overflow-y-auto rounded-[17px] py-10 px-2 xs:px-5 sm:px-5 md:px-10 lg:px-20"
                style={{
                    boxShadow: cardShadow,
                    width: "1127px",
                    maxWidth: "100%",
                    // height: "616px",
                }}
            >
                {results
                    ?.filter((item) => !item?.notAttempted)
                    .map((item, idx) => {
                        const isCorrect = item?.isCorrect === true;
                        const selectedAnswer =
                            item?.selectedOption || "No answer selected";
                        const correctAnswer = item?.correctOption || "N/A";
                        const explanation =
                            typeof item?.explanation === "string"
                                ? item.explanation.trim()
                                : "";
                        return (
                            <Fragment key={idx}>
                                <div className="flex w-full flex-col gap-4">
                                    <div className="flex items-center gap-3">
                                        <h2 className="text-[28px] text-[#161616]">
                                            {idx + 1}. {item?.question}
                                        </h2>
                                    </div>
                                   
                                </div>
                                <div className="flex w-full flex-col gap-10">
                                    <div className="flex flex-col gap-3 rounded-[17px] border border-solid border-[#8DF4A9] bg-[#D6FFE1] p-5">
                                        <div className="flex items-center gap-3">
                                            <img
                                                src={correctIcon}
                                                alt="Correct answer"
                                                className="shrink-0"
                                            />
                                            <p
                                                className={`${quizResultTextClass} min-w-0 flex-1`}
                                            >
                                                {correctAnswer}
                                            </p>
                                        </div>
                                        {explanation ? (
                                            <div className="flex flex-col gap-1">
                                                <span
                                                    className={
                                                        quizExplanationLabelClass
                                                    }
                                                >
                                                    Explanation:
                                                </span>
                                                <p className={quizResultTextClass}>
                                                    {explanation}
                                                </p>
                                            </div>
                                        ) : null}
                                    </div>
                                    {!isCorrect ? (
                                        <div className="rounded-[17px] border border-solid border-[#FF7C7C] bg-[#FFCBCB] p-5">
                                            <div className="flex items-center gap-3">
                                                <img
                                                    src={incorrectIcon}
                                                    alt="Selected answer"
                                                />
                                                <h2 className="text-[23px] text-[#161616]">
                                                    {selectedAnswer}
                                                </h2>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            </Fragment>
                        );
                    })}
            </div>
        </div>
    );
}

export default QuizeResults;
